/**
 * hero-navigation.js
 * Pins the hero-navigation nav grid below the sticky header once it scrolls
 * past. A zero-height spacer before the nav marks its natural top and reserves
 * its height while pinned, so content below never jumps. The pinned offset is
 * measured from the sticky header and written to `--sticky-offset`.
 *
 * Scoped per section instance via [data-section-id]; re-runs on
 * shopify:section:load in the theme editor.
 */
(function () {
  'use strict';

  function headerOffset() {
    var header = document.querySelector('.header--sticky');
    if (!header) return 0;
    // Use the header's live bottom edge, not its height: when the announcement
    // region slides away on scroll-down the height is unchanged but the visible
    // bottom drops, so reading .bottom keeps the nav pinned flush to the header.
    return Math.max(0, Math.round(header.getBoundingClientRect().bottom));
  }

  function initSection(root) {
    if (!root || root.dataset.heroNavReady === 'true') return;
    root.dataset.heroNavReady = 'true';

    if (root.dataset.enableSticky === 'false') return;

    var nav = root.querySelector('[data-hero-nav]');
    var spacer = root.querySelector('[data-hero-nav-spacer]');
    if (!nav || !spacer) return;

    var ticking = false;

    function update() {
      var offset = headerOffset();
      var natural = spacer.getBoundingClientRect().top;
      var shouldStick = natural <= offset;
      var isStuck = nav.classList.contains('is-stuck');

      if (shouldStick && !isStuck) {
        spacer.style.height = nav.offsetHeight + 'px';
        nav.classList.add('is-stuck');
      } else if (!shouldStick && isStuck) {
        nav.classList.remove('is-stuck');
        spacer.style.height = '0px';
      }
      if (nav.classList.contains('is-stuck')) {
        nav.style.setProperty('--sticky-offset', offset + 'px');
      }
      ticking = false;
    }

    function requestTick() {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }

    window.addEventListener('scroll', requestTick, { passive: true });
    window.addEventListener('resize', requestTick);
    update();
  }

  function initAll() {
    Array.prototype.slice
      .call(document.querySelectorAll('.hero-navigation[data-section-id]'))
      .forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target && e.target.querySelector ? e.target.querySelector('.hero-navigation[data-section-id]') : null;
    if (root) {
      root.dataset.heroNavReady = '';
      initSection(root);
    }
  });
})();
